import ACTIONS from './actions';
import { IUserInfo, IStoreInfo, IStoreListItem, IStoreTheme, IBannerTheme } from '@/types/homepage';
import { ICms } from '@/types/cms';

export interface InitialState {
  homeData?: ICms | null;
  deliveryDateInfo?: {
    delivery?: {
      available?: boolean;
      date?: string;
      end_time?: number;
    }[];
    pickup?: [];
    shipping_free_fee_global?: string;
    tip?: any;
  };
  userInfo?: IUserInfo;
  storeInfo?: IStoreInfo;
  storeList?: IStoreListItem[];
  storeTheme?: IStoreTheme;
  recommendBannerVisible?: boolean;
  //新主题的背景色和字体色
  bannerTheme?: IBannerTheme;
  //滚动距离超过新组件最后位置, 需要将fixed组件的主题色重置
  bannerThemeOrigin?: boolean;
}

export const initialState = {
  homeData: null,
  storeList: [],
  bannerTheme: {},
  bannerThemeOrigin: {}
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_HOME_INFO:
      return {
        ...state,
        homeData: action.payload
      };
    case ACTIONS.SET_DELIVERY_DATE_INFO:
      return {
        ...state,
        deliveryDateInfo: action.payload
      };
    case ACTIONS.SET_STORE_INFO:
      return {
        ...state,
        storeInfo: action.payload
      };
    case ACTIONS.SET_STORE_LIST:
      return {
        ...state,
        storeList: action.payload
      };
    case ACTIONS.UPDATE_REMIND:
      return {
        ...state,
        storeList: state.storeList.map(item => {
          if (action.payload.store_id === item.store_id) {
            return action.payload;
          }
          return item;
        })
      };
    case ACTIONS.RECOMMEND_BANNER_VISIBLE:
      return {
        ...state,
        recommendBannerVisible: action.payload
      };
    case ACTIONS.SET_BANNER_THEME:
      return {
        ...state,
        bannerTheme: action.payload,
        bannerThemeOrigin: action.payload
      };
    case ACTIONS.SCORELL_THEME_OVER: {
      return {
        ...state,
        bannerTheme: action.payload === false ? state.bannerThemeOrigin : {}
      };
    }
    default:
      return state;
  }
};
